<template>
    <div class="register">
      <v-content>
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <v-flex xs12 sm8 md4>
            <v-card class="elevation-12">
              <v-toolbar dark color="blue">
                <v-toolbar-title>Register</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                      v-model="email"
                      label="Email"
                      required
                    >
                    </v-text-field>
                    <v-text-field
                      v-model="password"
                      label="Password"
                      type="password"
                      required
                    >
                    </v-text-field>
                    <v-layout row>
                      <v-checkbox
                        v-model="admin"
                        :error-messages="errors.collect('checkbox')"
                        label="Admin"
                        type="admin"
                        required
                      ></v-checkbox><v-checkbox
                        v-model="standard"
                        :error-messages="errors.collect('checkbox')"
                        label="Standard"
                        type="standard"
                        required
                      ></v-checkbox>
                    </v-layout>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn block dark v-on:click="handler('saveInput', 'register')" color="blue">Register</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </v-content>
    </div>
</template>

<script>
import db from "./firebaseinit";
import firebase from 'firebase';
export default {
  name: 'register',
  data: function() {
    return {
      email: '',
      password: '',
      admin: false,
      standard: false
    };
  },
  methods: {
    register: function(e) {
      firebase
      .auth()
      .createUserWithEmailAndPassword(this.email, this.password)
      .then(
        user => {
        alert('Account created');
      },
      err => {
        alert(err.message);
      }
      );

      e.preventDefault();
    },
    saveInput () {
      db.collection('users').add({
        user: this.email,
        admin: this.admin,
        standard: this.standard
      })
      .then(docRef => this.$router.push('/'))
        .catch(error => console.log(err))
    },
    handler:function(saveInput, register){
      this.saveInput(saveInput),
      this.register(register)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Register.vue